import styled from 'styled-components';
import { Colors } from '../../../colors';
export const Divider = styled.div `
  margin: 10px 0;
  padding: 0;
  border-bottom: 1px solid ${Colors.GS500};
`;
